import Api from './api';
export const getPatrimonyGroups = async () => { 
  let data = [];
  await Api.get('/patrimonygroups')
      .then(result => {
          data = result.data
       })
       .catch(err => {
          data = err;
  });
  return data;
};
export const getPatrimonySubgroups = async (id) => { 
  let data = [];
  await Api.get('/patrimonysubgroups/group/'+id)
      .then(result => {
          data = result.data
       })
       .catch(err => {
          data = err;
  });
  return data;
};
